import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'

import classNames from 'classnames'

import {zoomIn, zoomOut} from '../../../actions/productDetailPage'
import * as pdp from '../../../store/productDetailPage'

import Svg from '../../Svg'
import zoomInSvg from '../../../../../svg/zoomin.svg'
import zoomOutSvg from '../../../../../svg/zoomout.svg'

function ProductZoomControls(props) {
  const zoomContainerClasses = classNames('zoom-controls-container', {
    'is--hidden': false,
  })
  const zoomInClasses = classNames('zoom-in-control', 'zoom-controls', {
    'is--disabled': props.isZoomedIn,
  })

  const zoomOutClasses = classNames('zoom-out-control', 'zoom-controls', {
    'is--disabled': !props.isZoomedIn,
  })
  return (
    <div className={zoomContainerClasses}>
      <button onClick={props.zoomIn}>
        <span className="u-sr-only">Zoom in</span>
        <Svg className={zoomInClasses} src={zoomInSvg} />
      </button>
      <button onClick={props.zoomOut}>
        <span className="u-sr-only">Zoom out</span>
        <Svg className={zoomOutClasses} src={zoomOutSvg} />
      </button>
    </div>
  )
}

ProductZoomControls.propTypes = {
  isZoomedIn: PropTypes.bool.isRequired,
  zoomIn: PropTypes.func.isRequired,
  zoomOut: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
  return {
    isZoomedIn: pdp.isZoomedIn(state),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    zoomIn: () => dispatch(zoomIn()),
    zoomOut: () => dispatch(zoomOut()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductZoomControls)
